// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getMessaging } from "firebase/messaging";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Firebase uygulamasını başlat
const app = initializeApp(firebaseConfig);

// Diğer servisleri export et
export const auth = getAuth(app);
// ignoreUndefinedProperties: undefined alanlar yazma sırasında hata fırlatmak yerine atlanır.
// Mevcut alanları SİLMEZ; sadece değeri undefined olanları yok sayar (yazma yolları için güvenlik ağı).
//
// localCache (IndexedDB kalıcı önbellek): Firebase okuma maliyetini düşürmenin en
// büyük kaldıracı. Kalıcı önbellek KAPALIYKEN her sayfa yenilemesi tüm listener
// sorgularını sıfırdan sunucudan okur. AÇIKKEN Firestore, yeniden kurulan her
// listener'a "resume token" gönderir; sunucu yalnızca DEĞİŞEN dokümanları
// döndürür. Değişmemiş dokümanlar için okuma faturalanmaz.
//
// persistentMultipleTabManager: kullanıcı CRM'i birden fazla sekmede açtığında
// sekmeler aynı IndexedDB önbelleğini paylaşır (tek sekme yöneticisiyle ikinci
// sekme önbelleksiz kalırdı).
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

// Functions servisini doğru bölge ile başlat
export const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || "europe-west3");
export const messaging = getMessaging(app);

// Eğer local'de Firebase Emulator ile test yapmak isterseniz bu bölümü aktif edebilirsiniz.
// if (window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }
